export enum ToastType {
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
}

/**
 * One button inside a toast. The store holds only serializable data, so the toast names the
 * action by id; `registerToastAction` (toastActions.ts) holds the handler.
 */
export interface ToastAction {
  label: string;
  actionId: string;
}

export interface ToastToDisplay {
  type: ToastType;
  title?: string;
  description: string;
  iconClassName?: string;
  autoHide?: boolean;
  uniqueId?: string;
  /**
   * An address the toast is about. It is shown under the description, with a
   * copy button and a way to open it — a published page is worth pasting
   * somewhere, and a toast that only announced it would send the artist
   * hunting for the address again. Web and Electron only.
   */
  linkUrl?: string;
  /** An optional button after the description. A click runs the action and closes the toast. */
  action?: ToastAction;
}

export interface ToastDisplayed extends ToastToDisplay {
  id: string;
  createdAt: number;
  isDismissed: boolean;
}

export interface ToastsStateType {
  toasts: ToastDisplayed[];
}

export const ToastsState: ToastsStateType = {
  toasts: [],
};
